const loadedScripts = new Map();
const loadedStylesheets = new Map();

/**
 * Load a theme stylesheet once (lazy panel/search/quick-add CSS).
 * @param {string} href - Absolute stylesheet URL from Liquid asset_url
 * @returns {Promise<void>}
 */
export function loadDeferredStylesheet(href) {
  if (!href) return Promise.resolve();

  const existing = loadedStylesheets.get(href);
  if (existing) return existing;

  const promise = new Promise((resolve, reject) => {
    const escaped = CSS.escape(href);
    if (document.querySelector(`link[rel="stylesheet"][href="${escaped}"]`)) {
      resolve();
      return;
    }

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.fetchPriority = 'low';
    link.onload = () => resolve();
    link.onerror = () => {
      loadedStylesheets.delete(href);
      reject(new Error(`Failed to load stylesheet: ${href}`));
    };
    document.head.appendChild(link);
  });

  loadedStylesheets.set(href, promise);
  return promise;
}

/**
 * Load a theme ES module script once (lazy panel/search scripts).
 * @param {string} src - Absolute script URL from Liquid asset_url
 * @returns {Promise<void>}
 */
export function loadDeferredScript(src) {
  if (!src) return Promise.resolve();

  const existing = loadedScripts.get(src);
  if (existing) return existing;

  const promise = new Promise((resolve, reject) => {
    if (document.querySelector(`script[type="module"][src="${CSS.escape(src)}"]`)) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.type = 'module';
    script.src = src;
    script.fetchPriority = 'low';
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
    document.head.appendChild(script);
  });

  loadedScripts.set(src, promise);
  return promise;
}
